import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { Card, Form, Input, Button, Space, Spin, message, Popconfirm } from 'antd';
import { ArrowLeftOutlined, SaveOutlined, DeleteOutlined } from '@ant-design/icons';
import { getMusicStyle } from '../../graphql/queries';
import { updateMusicStyle, deleteMusicStyle } from '../../graphql/mutation';

const MusicStyleDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const { loading } = useQuery(getMusicStyle, {
    variables: { id },
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data?.getMusicStyle) {
        form.setFieldsValue({
          name: data.getMusicStyle.name,
          icon: data.getMusicStyle.icon,
        });
      }
    }
  });

  const [update, { loading: updating }] = useMutation(updateMusicStyle, {
    onCompleted: () => {
      message.success('Music style updated');
      navigate('/music-styles');
    },
    onError: (error) => {
      message.error(`Failed to update: ${error.message}`);
    }
  });

  const [deleteStyle, { loading: deleting }] = useMutation(deleteMusicStyle, {
    onCompleted: () => {
      message.success('Music style deleted');
      navigate('/music-styles');
    },
    onError: (error) => {
      message.error(`Failed to delete: ${error.message}`);
    }
  });

  const handleSubmit = (values) => {
    update({
      variables: {
        id,
        name: values.name,
        icon: values.icon,
      }
    });
  };

  const handleDelete = () => {
    deleteStyle({ variables: { id } });
  };

  if (loading) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <Card
        title={
          <Space>
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/music-styles')}>
              Back
            </Button>
            <span>Edit Music Style</span>
          </Space>
        }
        extra={
          <Popconfirm
            title="Delete this style?"
            onConfirm={handleDelete}
            okText="Yes"
            cancelText="No"
          >
            <Button danger icon={<DeleteOutlined />} loading={deleting}>
              Delete
            </Button>
          </Popconfirm>
        }
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          style={{ maxWidth: 500 }}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please enter a name' }]}
          >
            <Input placeholder="Style name" />
          </Form.Item>

          <Form.Item
            label="Icon (Emoji)"
            name="icon"
            rules={[{ required: true, message: 'Please enter an icon' }]}
          >
            <Input placeholder="🎵" style={{ fontSize: 24 }} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={updating}>
              Save Changes
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default MusicStyleDetail;
